<template>
    <div>
        <h3 @click="toggle()" class="mb-0 pb-2" :class="{ 'd-flex align-item-center justify-content-between': !isDisabled, 'active': isActive }">
            <div><slot name="title"></slot></div>
            <div class="toggle" v-if="!isDisabled">{{ isActive ? "-" : "+" }}</div>
        </h3>
        <collapse-transition>
            <div v-show="isActive">
                <div class="pb-2">
                    <slot></slot>
                </div>
            </div>
        </collapse-transition>
    </div>
</template>

<script>
/*
* Collapsible Vue component
* ---
* Example usage:
*
* <collapsible>
*   <template v-slot:title>Accordion Title</template>
*   <template>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</template>
* </collapsible>
*/

import {CollapseTransition} from 'vue2-transitions';

export default {
    components: {
        CollapseTransition
    },

    props: ["isDisabled"],

    data() {
        return {
            isActive: false
        }
    },

    created() {
        if (this.isDisabled) {
            this.isActive = true;
        }
    },

    methods: {
        toggle() {
            if (this.isDisabled) return;
            this.isActive = !this.isActive;
        },

        close() {
            if (this.isDisabled) return;
            this.isActive = false;
        },
        
        open() {
            if (this.isDisabled) return;
            this.isActive = true;
        }
    }
}
</script>

<style lang="scss" scoped>
h3 {
    cursor: pointer;
}

.toggle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.4em;
    height: 1.4em; 
    transition: all 0.3s ease-in-out;

    .active & {
        transform: rotate(180deg);
    }
}
</style>
